import { Text } from '@acv/clearcar-component-lib';

export const ModalHeader = ({ text }) => <Text headingType="h3">{text}</Text>;
